<template>
  <v-container>
    <static-page-content uri="/static/pages/overview" />
    <static-page-content uri="/static/pages/demos-bc-artist" />
    <bc-artist :artist="$config.methods.album.artist" :class="['mt-4']" />
  </v-container>
</template>
<script>
export default {
  name: 'PageIndex'
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue